/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DongTaiBaoBiaoChaXunDTO,
  ResponseApiDongTaiBaoBiaoChaXunJieGuoDTO,
  ResponseApiListString,
  ResponseApiListString1,
  ResponseApiString1,
  WeiDuLieBiaoChaXunDTO,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class DongTaiBaoBiaoChaXun<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags DongTaiBaoBiaoChaXun
   * @name GetDimensionListUsingPost
   * @summary 获取聚合维度列表
   * @request POST:/dsp-admin/api/dynamic-report/dimension-list
   * @secure
   */
  getDimensionListUsingPost = (
    queryDTO: WeiDuLieBiaoChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListString1, void>({
      path: `/dsp-admin/api/dynamic-report/dimension-list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags DongTaiBaoBiaoChaXun
   * @name ExportDynamicReportAsXlsxUsingPost
   * @summary 导出动态报表为XLSX格式
   * @request POST:/dsp-admin/api/dynamic-report/export-xlsx
   * @secure
   */
  exportDynamicReportAsXlsxUsingPost = (
    queryDTO: DongTaiBaoBiaoChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/dsp-admin/api/dynamic-report/export-xlsx`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags DongTaiBaoBiaoChaXun
   * @name QueryDynamicReportUsingPost
   * @summary 动态报表查询
   * @request POST:/dsp-admin/api/dynamic-report/query
   * @secure
   */
  queryDynamicReportUsingPost = (
    queryDTO: DongTaiBaoBiaoChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiDongTaiBaoBiaoChaXunJieGuoDTO, void>({
      path: `/dsp-admin/api/dynamic-report/query`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags DongTaiBaoBiaoChaXun
   * @name GetTableInfoUsingGet
   * @summary 获取表的字段信息
   * @request GET:/dsp-admin/api/dynamic-report/table-info/{tableCode}
   * @secure
   */
  getTableInfoUsingGet = (tableCode: string, params: RequestParams = {}) =>
    this.request<ResponseApiString1, void>({
      path: `/dsp-admin/api/dynamic-report/table-info/${tableCode}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DongTaiBaoBiaoChaXun
   * @name GetSupportedTablesUsingGet
   * @summary 获取支持的报表表列表
   * @request GET:/dsp-admin/api/dynamic-report/tables
   * @secure
   */
  getSupportedTablesUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiListString, void>({
      path: `/dsp-admin/api/dynamic-report/tables`,
      method: "GET",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new DongTaiBaoBiaoChaXun();
